@if (!noJobLeft()) {
  <div class="columns">
    <div
      class="column pdf-container darkmode-ignore"
      [class.is-6]="isUpgrightDisplay()"
      [class.is-8]="!isUpgrightDisplay()"
    >
      @if (pdfUrl()) {
        <ng2-pdfjs-viewer
          #pdfViewer
          viewerId="JobPdfViewer"
          [pdfSrc]="pdfUrl()"
          (onDocumentLoad)="pdfViewerLoaded($event)"
          [pagemode]="pagemode"
          [showSpinner]="false"
          (onPageChange)="pdfViewerPageChange($event)"
        ></ng2-pdfjs-viewer>
      }

      <div class="flex">
        @if (isClarification()) {
          <div class="box is-fullwidth">
            <b>PreviousJobID: </b> {{ previousJobId() }} <br />
            <b>ID: </b> {{ jobId() }}<br />
            <b>Courier Link: </b>
            <a href="{{ courierBaseUrl }}/jobs/captureTransaction/{{ jobId() }}"
              >{{ courierBaseUrl }}/jobs/captureTransaction/{{ jobId() }}</a
            >
            <br />

            @if (job().envelope.newIban) {
              <span> <b>New Iban: </b> {{ job().envelope.newIban | iban }} </span>
            }
          </div>
        }
      </div>
    </div>

    <form class="column" [formGroup]="form">
      <app-siblings [jobId]="$safeNavigationMigration(job()?.id)"></app-siblings>

      @if (hasClosedStatus()) {
        <div class="notification is-warning" translate="identifyDocument.closed"></div>
      }

      @if (hasReviewReason()) {
        <div class="notification is-danger">
          {{ job().reviewReason }}
        </div>
      }

      <div class="columns is-gapless is-multiline mb-1">
        <div class="column is-full-widescreen is-half-fullhd">
          <b class="has-text-primary">{{ tenantInfos()?.bankName || tenant() }}</b>
          <span class="ml-1">( {{ tenantInfos()?.blz }} )</span>
        </div>
        <div class="column is-flex">
          <fino-icon class="mr-2" icon="Envelope"></fino-icon
          ><span>{{ tenantInfos()?.kwhEmail }}</span>
        </div>
      </div>

      <div>
        @for (documentTypes of documentTypeItems(); track $index) {
          @for (type of documentTypes; track $index) {
            <span
              class="tag is-size-6 m-2 has-click has-text-weight-bold"
              [class.is-primary]="type.value == documentType"
              [class.is-danger]="documentTypeError"
              (click)="selectDocumentType(type.value)"
              [attr.data-testid]="type.value + '_Type'"
              >{{ type.label | translate }}
            </span>
          }
          @if ($first) {
            <div class="divider m-0"></div>
          }
        }
      </div>

      <div class="is-flex is-flex-direction-column ml-2 iban-container">
        @for (iban of ibansOnCurrentPage(); track iban.id) {
          <button
            class="tag is-black has-click mb-2 is-medium is-size-6"
            ngxClipboard
            fino-button
            [cbContent]="iban"
            aria-label="Copy IBAN"
          >
            <span
              [innerHtml]="iban | ibanColor: $safeNavigationMigration(tenantInfos()?.blz)"
            ></span>
            <fino-icon icon="Copy Paste 1"></fino-icon>
          </button>
        }
      </div>

      <div class="columns my-0 pl-2">
        <div class="column is-10">
          <div>
            <b [class.has-text-danger]="customerDiffers()"
              ><span translate="identifyDocument.customer"></span>: {{ oldBankCustomerName() }}</b
            >
            <app-iban-typeahead
              name="oldIban"
              [openTypeahead]="ibanTypeaheadOpenEvents.oldIban"
              (ibanSelected)="ibanSelected($event)"
              [form]="form"
              [tenant]="tenant()"
              [disableTypeahead]="disableTypeahead()"
              [countryCode]="$safeNavigationMigration(tenantInfos()?.countryCode)"
            ></app-iban-typeahead>
          </div>
          <div class="pt-1 mb-4">
            <b [class.has-text-danger]="customerDiffers()"
              ><span translate="identifyDocument.customer"></span>: {{ newBankCustomerName() }}</b
            >
            <app-iban-typeahead
              name="newIban"
              [openTypeahead]="ibanTypeaheadOpenEvents.newIban"
              (ibanSelected)="ibanSelected($event)"
              [form]="form"
              [tenant]="tenant()"
              [disableTypeahead]="disableTypeahead()"
              [countryCode]="$safeNavigationMigration(tenantInfos()?.countryCode)"
            ></app-iban-typeahead>
          </div>
        </div>

        <div class="column is-flex is-justify-content-center is-align-items-center">
          <button
            class="mb-4"
            type="button"
            (click)="switchIbanValues()"
            fino-button
            icon="Button Shuffle"
            [disabled]="!canSwitchIbans"
            aria-label="Switch IBANs"
          ></button>
        </div>
      </div>

      <app-rejection-reason
        [jobId]="job().id"
        [documentType]="documentType"
        [isClarification]="isClarification()"
        [form]="form"
        [tenantInfos]="tenantInfos"
        (deleteJobDone)="deleteJobDone()"
      >
      </app-rejection-reason>

      <div class="mt-4 pl-4">
        @if (!isClarification()) {
          <form [formGroup]="loadNextDocumentForm">
            <fino-checkbox formControlName="loadNext" label="identifyDocument.loadNext">
            </fino-checkbox>
          </form>
        }

        <div class="columns">
          <div class="column">
            <button
              class="is-fullwidth"
              [primary]="!showDuplicateListLink()"
              data-testid="submit"
              (click)="maybeSubmitJob()"
              [loading]="!submitSubscription.closed"
              [disabled]="form.invalid"
              fino-button
              translate="identifyDocument.save"
            ></button>
          </div>

          @if (showDuplicateListLink()) {
            <div class="column">
              <button
                class="is-fullwidth"
                [primary]="true"
                type="button"
                data-testid="duplicateListButton"
                (click)="loadDuplicateList()"
                fino-button
                translate="identifyDocument.openDuplicate"
              ></button>
            </div>
          }
        </div>
      </div>

      <app-tenant-infos [infos]="sidebarInfos()"></app-tenant-infos>
    </form>
  </div>
} @else {
  <div
    data-testid="no-job-left"
    class="is-flex is-justify-content-center is-align-items-center is-fullheight"
  >
    <h5 class="title is-size-5" translate="identifyDocument.empty"></h5>
  </div>
}
